import styled from 'styled-components';
import { ANTD_GRAY } from '../../entity/shared/constants';

export const SuggestionText = styled.div`
    margin-left: 12px;
    margin-top: 2px;
    margin-bottom: 2px;
    color: ${ANTD_GRAY[9]};
    font-size: 16px;
    overflow: hidden;
`;
